import { createI18n } from 'vue-i18n'
import th from '@/data/locales/th.json'
import en from '@/data/locales/en.json'
// import jp from './assets/locales/jp.json'

export const defaultLocale = 'th'

export const i18n = createI18n({
  locale: sessionStorage.getItem('locale') ?? defaultLocale,
  fallbackLocale: 'en',
  messages: { th, en },
  legacy: false,
})

export default i18n

//-------------------------------------------------------------------
// save locale to session-storage
import { watch } from 'vue'
watch(i18n.global.locale, () => {
  console.debug('locale session-storage', { locale: i18n.global.locale.value, welcome: i18n.global.t('welcome') })
  sessionStorage.setItem('locale', i18n.global.locale.value)
})
//-------------------------------------------------------------------
